module.exports = __webpack_public_path__ + "static/media/up.52722c54.svg";